module.exports = __webpack_public_path__ + "img/gridsome.8ad4b76f.png";